<template>
  <section>
    <v-data-iterator
      :items="groups"
      item-key="id"
      :items-per-page.sync="limit"
      :page="page"
      :loading="groupsLoading"
      :search="search"
      :server-items-length="totalGroups"
      loading-text="Loading groups..."
      no-results-text="Could not find such a group..."
      hide-default-footer
      must-sort
    >
      <template v-slot:no-data>
        <v-alert type="info" border="left" class="mt-4" dismissible v-if="!groupsLoading">
          Your bot has not been added to any groups yet.
          <br />
          <small>Add your bot to the groups you would like it to manage and then click the refresh icon.</small>
        </v-alert>
      </template>
      <template v-slot:header>
        <v-toolbar>
          <v-progress-linear
            v-if="updateTelegram"
            absolute
            top
            indeterminate
            color="primary"
            height="7"
          ></v-progress-linear>
          <v-toolbar-title class="headline d-flex">
            <v-icon class="pr-2 align-self-center" color="grey" large>mdi-account-group</v-icon>
            <span class="align-self-center">Groups</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn-toggle v-model="sortDesc" mandatory>
            <v-btn text color="accent" :value="false">
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn text color="accent" :value="true">
              <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
          </v-btn-toggle>

          <v-menu
            bottom
            left
            :close-on-click="!search"
            :close-on-content-click="false"
            :offset-y="false"
          >
            <template v-slot:activator="{ on }">
              <v-btn color icon v-on="on">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <v-toolbar flat dense :min-width="400" :max-width="500">
              <v-text-field
                v-model="search"
                hide-details
                prepend-icon="mdi-magnify"
                flat
                clearable
                single-line
                filled
                placeholder="Search group title..."
              ></v-text-field>
            </v-toolbar>
          </v-menu>
          <!--<v-btn title="Reload groups" color="primary" icon large @click.stop="refresh()">
            <v-icon>mdi-cached</v-icon>
          </v-btn>-->
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col v-for="item in props.items" :key="item.name" cols="12" :md="limit === 1 ? 12 : 6">
            <GroupItem :group="item" :geofences="geofences"></GroupItem>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2 mx-4" align="center" justify="center">
          <span class="grey--text">Groups per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on">
                {{ limit }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">Page {{ page }} of {{ pageLength }}</span>
          <v-btn text color="primary" class="mr-1" @click="formerPage()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn text color="primary" class="ml-1" @click="nextPage()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </section>
</template>

<script>
import { makeFindMixin } from "feathers-vuex";
import { mapGetters, mapActions } from "vuex";
import GroupItem from "@/components/groups/Group";

export default {
  data: () => ({
    updateTelegram: false,
    itemsPerPageArray: [2, 4, 6, 8],
    page: 1,
    limit: 4,
    skip: 0,
    search: "",
    sortBy: "title",
    sortDesc: false,
    keys: ["Title"],
  }),
  mixins: [
    makeFindMixin({ service: "groups", watch: true }),
    makeFindMixin({ service: "geofences" }),
  ],
  async mounted() {},
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    groupsLoading() {
      return this.isFindGroupsPending;
    },
    totalGroups() {
      return this.groupsPaginationData.default &&
        this.groupsPaginationData.default.mostRecent.total
        ? this.groupsPaginationData.default.mostRecent.total
        : 0;
    },
    pageLength() {
      return this.totalGroups % this.limit === 0
        ? this.totalGroups / this.limit
        : Math.ceil(this.totalGroups / this.limit);
    },
    hasNonAdminGroup() {
      return (
        this.groups &&
        this.groups.findIndex(
          (group) => group.permissions && group.permissions.status !== "administrator"
        ) !== -1
      );
    },
    groupsParams() {
      return {
        query: {
          $limit: this.limit,
          $skip: this.skip,
          $sort: {
            title: this.sortDesc ? -1 : 1,
          },
          $eager: "[geofences, files]",
          deleted: false,
          enabled: true,
          title: { $regex: this.search || "", $options: "i" },
        },
      };
    },
    groupsFetchParams() {
      return {
        query: {
          $limit: this.limit,
          $skip: this.skip,
          $sort: {
            title: this.sortDesc ? -1 : 1,
          },
          $eager: "[geofences, files]",
          $modify: ["geofenceOmit"],
          $modifyEager: {
            files: {
              for: { $in: ["profilePhoto", "registrationRestriction"] },
            },
          },
          deleted: false,
          title: { $ilike: `%${this.search || ""}%` },
        },
        debounce: 1000,
      };
    },
    geofencesParams() {
      return {
        query: {
          $sort: {
            name: 1,
          },
        },
      };
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    async refresh() {
      this.updateTelegram = true;
      await this.findGroups({
        query: {
          options: {
            update: { telegram: true },
          },
        },
      });
      this.updateTelegram = false;
    },
    nextPage() {
      if (this.page + 1 <= this.pageLength) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.limit = number;
      this.page = 1;
    },
  },
  watch: {
    page(now) {
      this.skip = now * this.limit - this.limit;
    },
  },
  components: {
    GroupItem,
  },
};
</script>